import { forwardRef, ReactNode } from "react";

import ChevronDown from "@/assets/icons/chevron-down.svg";
import { cx } from "@/utils";
import Adornment from "@components/Field/Adornment";

import styles from "../Base.module.css";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  block?: boolean;
  options?: { label: string | number; value: string | number }[];
  nullable?: boolean;
  error?: boolean;
  placeholder?: ReactNode;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      error = false,
      className,
      block,
      nullable = false,
      placeholder,
      startAdornment = null,
      endAdornment = null,
      disabled,
      options,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <span
        className={cx(styles.control, { [styles.block]: block }, className)}
      >
        {startAdornment}
        <select
          aria-disabled={disabled}
          aria-invalid={error}
          className={cx(styles.root, styles.adornedEnd, {
            [styles.adornedStart]: startAdornment !== null,
          })}
          ref={ref}
          {...props}
        >
          {Boolean(nullable === true || placeholder) && (
            <option disabled={!nullable} value="">
              {placeholder || "-"}
            </option>
          )}
          {options &&
            options.map(({ label, value, ...rest }, i) => (
              <option key={i} value={value} {...rest}>
                {label}
              </option>
            ))}
          {children}
        </select>
        {endAdornment || (
          <Adornment position="end">
            <ChevronDown />
          </Adornment>
        )}
      </span>
    );
  }
);

Select.displayName = "Select";

export default Select;
